<template>
    <div class="c-discover-power">
        <div class="c-discover-power__heading">
            <div class="c-discover-power__title">
                <h2>
                    {{ content.title }}
                </h2>
            </div>
            <div
                v-if="showSynopsis && content.synopsis && content.synopsis!==''"
                class="c-discover-power__synopsis"
            >
                <p>
                    {{ content.synopsis }}
                </p>
            </div>
        </div>

        <div class="c-discover-power__content">
            <y-row>
                <y-col
                    v-for="(item, index) in content.albums"
                    :key="index"
                    md="6"
                    sm="12"
                    lg="4"
                >
                    <div class="c-discover-power__content__accordion-box">
                        <div
                            class="c-discover-power__content__accordion-box__accordion"
                            @click="openOrCloseAccordion(index)"
                        >
                            <div
                                :style="borderColorHandler(index)"
                                class="img-box"
                            >
                                <img
                                    :src="item.link"
                                    :alt="item.title"
                                >
                                <template v-if="item.hyperlink">
                                    <y-button
                                        v-if="!isTag(item.hyperlink)"
                                        :tag="isLink(item.hyperlink) ? 'a' : 'router-link'"
                                        :to="item.hyperlink"
                                        :href="item.hyperlink"
                                        flat
                                        color="white"
                                        class="learn-more-link"
                                        :icon-append="`fa-arrow-${$i18n.locale === 'ar' ? 'left' : 'right'}`"
                                    >
                                        {{ $t('home.discover.link') }}
                                    </y-button>
                                    <span
                                        v-else
                                        class="info-tag"
                                    >
                                        {{ getTagValue(item.hyperlink) }}
                                    </span>
                                </template>
                            </div>
                            <div class="title">
                                <h3>
                                    {{ item.title }}
                                </h3>
                                <y-icon
                                    icon="chevron-down"
                                    :class="isShowing === index ? 'rotate' : ''"
                                />
                            </div>
                        </div>
                        <div
                            :id="`panel-${index}`"
                            class="c-discover-power__content__accordion-box__panel"
                        >
                            <p>
                                {{ item.description }}
                            </p>

                            <y-button
                                v-if="item.hyperlink && !isTag(item.hyperlink)"
                                :tag="isLink(item.hyperlink) ? 'a' : 'router-link'"
                                :to="item.hyperlink"
                                :href="item.hyperlink"
                                flat
                                color="white"
                                class="learn-more-link-panel"
                                :icon-append="`fa-arrow-${$i18n.locale === 'ar' ? 'left' : 'right'}`"
                            >
                                {{ $t('home.discover.link') }}
                            </y-button>
                        </div>
                    </div>
                </y-col>
                <y-col
                    v-if="!removeBanner"
                    md="12"
                    sm="12"
                    lg="8"
                >
                    <div
                        class="c-discover-power__content__start-now"
                        :class="$i18n.locale !== 'ar' ? 'first-bg' : 'sec-bg'"
                    >
                        <div
                            class="c-discover-power__content__start-now__bg"
                            :class="$i18n.locale === 'ar' ? 'first-bg' : 'sec-bg'"
                        >
                            <h5>
                                {{ $t('home.discover_power.unlock_text') }}
                            </h5>
                            <div class="d-f justify-content-center align-items-center">
                                <y-button
                                    class="text-box-btn"
                                    color="primary"
                                    :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                                    :to="content.custom['button-link']"
                                    :href="content.custom['button-link']"
                                >
                                    {{ content.custom['button-title'] }}
                                </y-button>
                            </div>
                        </div>
                    </div>
                </y-col>
            </y-row>
        </div>
        <div
            v-if="customBtn"
            class="c-discover-power__action"
        >
            <y-button
                v-if="!buttonClass"
                :tag="isLink(customBtn['button-link']) ? 'a' : 'router-link'"
                :href="customBtn['button-link']"
                :to="customBtn['button-link']"
                :content="customBtn['button-title']"
                color="primary"
                size="medium"
                flat
                :no-padding="true"
            />
            <y-button
                v-else
                :class="{[buttonClass]: !!buttonClass}"
                color="primary"
                size="medium"
                flat
                :no-padding="true"
                :content="customBtn['button-title']"
            />
        </div>
    </div>
</template>

<script>
    import { isLink, isTag, getTagValue } from '@/helpers/helpers';
    import YIcon from '@groot-components/icon';

    export default {
        name      : 'DiscoverPower',
        components: {
            YIcon,
        },
        props: {
            content     : Object,
            removeBanner: {
                type   : Boolean,
                default: false,
            },
            showSynopsis: Boolean,
            customBtn   : Object,
            buttonClass : String,
        },
        /**
         *@inheritDoc
         */
        data() {
            return {
                showAccordion: {},
                isShowing    : null,
                colors       : [
                    '#FB646D',
                    '#5CC97B',
                    '#EB83CF',
                    '#B764FB',
                    '#1B75FD',
                    '#FFD166',
                    '#FF6D35',
                ],
            };
        },

        methods: {
            isLink,
            isTag,
            getTagValue,
            /**
             * open or close accordion handler
             *
             * @param {*} index
             */
            openOrCloseAccordion(index) {
                const panel = document.getElementById(`panel-${index}`);
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                    if (this.showAccordion[index]) {
                        delete this.showAccordion[index];
                        this.isShowing = null;
                    }
                } else {
                    panel.style.maxHeight = `${panel.scrollHeight}px`;
                    this.showAccordion[index] = true;
                    this.isShowing = index;
                }
                /**
                 * This code is for closing unrelated Accordions
                 */
                Object.keys(this.showAccordion).forEach((key) => {
                    const otherPanel = document.getElementById(`panel-${key}`);
                    if (key !== index.toString() && otherPanel.style.maxHeight) {
                        otherPanel.style.maxHeight = null;
                        delete this.showAccordion[key];
                    }
                });
            },

            /**
             * border color handler
             *
             * @param {*} index
             * @returns {string}
             */
            borderColorHandler(index) {
                return `border-${this.$i18n.locale === 'ar' ? 'right' : 'left'}: 2px solid ${this.colors[index % this.colors.length]}`;
            },
        },
    };
</script>

<style lang="scss" src="./index.scss" ></style>
